import { render, staticRenderFns } from "./SolutionDataPanel.vue?vue&type=template&id=ef6a4da2&scoped=true&"
import script from "./SolutionDataPanel.vue?vue&type=script&lang=js&"
export * from "./SolutionDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./SolutionDataPanel.vue?vue&type=style&index=0&id=ef6a4da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6a4da2",
  null
  
)

export default component.exports